import type { CSSProperties, FC, ReactNode } from 'react'

import Link from 'next/link'
import { useScrollProgress } from '@/hooks/use-scroll-progress'
import Reveal from '@/components/motion/reveal'
import SplitWords from '@/components/motion/split-words'

/* The closing band: night ink with a navy and plum bloom rising from the bottom edge. */
const FinalCta: FC = (): ReactNode => {
    const ref = useScrollProgress<HTMLDivElement>({ start: 1.05, end: 0.4 })

    return (
        <section
            id='get-started'
            aria-labelledby='cta-title'
            data-header-theme='dark'
            className='relative isolate overflow-hidden border-y border-dashed border-night-line bg-night text-night-ink'
        >
            <div
                ref={ref}
                aria-hidden='true'
                className='paint-dusk grain pointer-events-none absolute inset-0 [--grain-opacity:0.35] [--p:1]'
                style={{ opacity: 'calc(0.45 + var(--p) * 0.55)', transform: 'translate3d(0, calc((1 - var(--p)) * 40px), 0)' } as CSSProperties}
            />

            <div className='container-page relative flex min-h-[30rem] flex-col items-center justify-center gap-7 py-28 text-center sm:min-h-[38rem] sm:py-36'>
                <SplitWords
                    id='cta-title'
                    as='h2'
                    by='letter'
                    text='Give production a steady hand.'
                    className='font-heading text-[clamp(2.5rem,5.4vw,4.1rem)] font-normal leading-[1.04] tracking-[-0.025em] text-white text-balance'
                />

                <Reveal delay={260}>
                    <p className='max-w-[48rem] text-pretty text-[17px] leading-relaxed text-night-muted sm:text-[19px]'>
                        Forge joins your team, learns how your environment really works and makes it a little more reliable every week.
                    </p>
                </Reveal>

                <Reveal delay={380} className='pt-4'>
                    <Link
                        href='/demo'
                        className='btn btn-night btn-lg h-12 px-7 text-[16px]'
                    >
                        Book a demo
                    </Link>
                </Reveal>
            </div>
        </section>
    )
}

export default FinalCta
